const STORE_SERVER_URL = process.env.REACT_APP_STORE_SERVER_URL || "http://localhost:8085";


async function StoreApiFetch(path, options = {}) {
    const {
        method = "GET",
        body = null,
        headers = {},
    } = options;
    
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    
    const requestHeaders = {
        "Content-Type": "application/json",
        ...headers,
    };

    const response = await fetch(`${STORE_SERVER_URL}${normalizedPath}`, {
        method,
        headers: requestHeaders,
        ...(body ? { body: JSON.stringify(body) } : {}),
    });

    let payload = {};
    try {
        payload = await response.json();
    } catch (error) {
        console.error("Error parsing JSON response:", error);
    }

    if (!response.ok) {
        const requestError = new Error(
            payload.error || payload.message || "An error occurred while fetching data."
        );
        requestError.status = response.status;
        requestError.details = payload.details;
        throw requestError;
    }

    return payload;
} 

export async function getProducts() {
    return await StoreApiFetch("/products", {
        method: "GET",
    });
}

export async function getProductById(productId) {
    const response = await StoreApiFetch(`/products/${productId}`, {
        method: "GET",
    });

    return response.product;
}


export async function addToCart(payload) {
    const response = await StoreApiFetch("/cart", {
        method: "POST",
        body: payload,
    });
    return response;    
}

export async function getCart() {
    const cartToken = localStorage.getItem("cartToken");

    if (!cartToken) {
        return null; // or { cart: null }
    }

    return await getCartByToken(cartToken);
}

async function getCartByToken(cartToken) {
    const response = await StoreApiFetch(`/cart/${encodeURIComponent(cartToken)}`, {
        method: "GET",
    });

    return response.cart;
}


export async function updateCartItemQuantity(cartToken, variantId, newQuantity) {
    const response = await StoreApiFetch(`/cart/${cartToken}/updateQuantity/${variantId}`, {
        method: "POST",
        body: { quantity: newQuantity },
    });

    return response.cart;
}

export async function removeCartItem(cartToken, variantId) {
    const response = await StoreApiFetch(`/cart/${cartToken}/removeItem/${variantId}`, {
        method: "DELETE",
    });

    return response.cart;
}

export async function clearCartItem(cartToken, variantId) {
    return await StoreApiFetch(
        `/cart/${encodeURIComponent(cartToken)}/${encodeURIComponent(variantId)}/clear`,
        { method: "POST" }
    );
}

export async function fedexShippingRate(zipCode, quantity, cartToken = localStorage.getItem("cartToken")) {
    const normalizedZip = Number(String(zipCode).replace(/\D/g, ""));
    const normalizedQuantity = Number(quantity);
    const resolvedCartToken = cartToken || localStorage.getItem("cartToken");

    const requestBody = {
        zip_code: normalizedZip,
        quantity: normalizedQuantity,
    };

    if (resolvedCartToken) {
        requestBody.cart_token = resolvedCartToken;
    }

    const response = await StoreApiFetch("/checkout/getAdditionalFee", {
        method: "POST",
        body: requestBody,
    });
    console.log("Additional fee response:", response);

    return {
        rate: Number(response?.rate ?? 0),
        tax: Number(response?.tax ?? 0),
        taxCents: Number(response?.taxCents ?? 0),
        currency: response?.currency ?? "USD",
        serviceType: response?.serviceType ?? null,
        packageCount: Number(response?.packageCount ?? 0),
        totalWeight: Number(response?.totalWeight ?? 0),
        raw: response,
    };
}


export async function createPaymentIntent(cartToken, deliveryInfo, billingInfo) {
    const response = await StoreApiFetch(`/checkout/payments/create-intent/${cartToken}`, {
        method: "POST",
        body: {
            destinationZIP: deliveryInfo.zip,
            deliveryInfo,
            billingInfo,
        },
    });
    return response;
}

export async function createInventoryTransaction(cartToken, payload) {
    return await StoreApiFetch(`/checkout/inventory/transaction/${encodeURIComponent(cartToken)}`, {
        method: "POST",
        body: payload,
    });
}

export async function getOrderReceipt(orderId) {
    const response = await fetch(`${STORE_SERVER_URL}/checkout/receipt/${encodeURIComponent(orderId)}`);

    if (!response.ok) {
        let message = "Unable to retrieve the receipt.";
        try {
            const payload = await response.json();
            message = payload.message || message;
        } catch (error) {
            console.error("Error parsing receipt error response:", error);
        }
        throw new Error(message);
    }

    return response.blob();
}